import { render, staticRenderFns } from "./GwLogin.vue?vue&type=template&id=0bcfe516&scoped=true&"
import script from "./GwLogin.vue?vue&type=script&lang=js&"
export * from "./GwLogin.vue?vue&type=script&lang=js&"
import style0 from "./GwLogin.vue?vue&type=style&index=0&id=0bcfe516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcfe516",
  null
  
)

export default component.exports